import React, { useEffect } from 'react';
import { CssBaseline, ThemeProvider } from '@mui/material';
import createTheme from './theme';
import { AppStateProvider } from './states/app-state';
import Scaffold from './containers/Scaffold';
import setHotjar from './tags/hotjar'; // added by Bearer Web Developer
import metaPixelCode from './tags/metaPixelCode'; // added by Bearer Web Developer
import googleTagManager from './tags/googleTagManager'; // added by Bearer Web Developer
import { BearerApi, getRemoteConfigData } from './api/bearer-api';
import logIndevelopment from './app/logIndevelopment'; // added by Bearer Web Developer

// added by Bearer Web Developer start
const getinitialData = async () => {

  BearerApi.callApiWithAppCheck();
  const result = await getRemoteConfigData();
  logIndevelopment();
  if (result?.environmentCode === "PRODUCTION") {
    setHotjar();
    metaPixelCode();
    googleTagManager();
  }
}

function App() {
  useEffect(() => {
   getinitialData();

  }, []);
// added by Bearer Web Developer end
  return (
    <ThemeProvider theme={createTheme}>
      <CssBaseline />
      <AppStateProvider>
        <Scaffold />
      </AppStateProvider>
    </ThemeProvider>
  );
}

export default App;
